import React from 'react';
import { Helmet } from 'react-helmet-async';
import MobileAppDev from '../components/MobileAppDev';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'Mobile App Development', item: 'https://wayug.com/mobile-app-development' },
  ],
};

export default function MobileAppDevPage() {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>Mobile App Development Company Delhi NCR | Android &amp; iOS Apps – Wayug</title>
        <meta
          name="description"
          content="Custom mobile app development company in Delhi NCR &amp; Noida. Flutter, React Native, iOS &amp; Android app development for B2B enterprises and startups."
        />
        <link rel="canonical" href="https://wayug.com/mobile-app-development" />
        <meta property="og:title" content="Mobile App Development Company Delhi NCR | Wayug Infotech" />
        <meta
          property="og:description"
          content="Native and cross-platform mobile app development. High performance, intuitive UI/UX design, and Play Store/App Store publishing."
        />
        <meta property="og:url" content="https://wayug.com/mobile-app-development" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
      <MobileAppDev />
    </div>
  );
}
